module.exports = __webpack_public_path__ + "static/pic_service1-f2c3e9374fbc9e940b771cebeef1acd4.jpg";